import React, { useEffect } from 'react';
import './widget-box.styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import CommonWidgetBox from './common-widgetBox.component';
import {
  trainingcoursedata,
  resourcesdata,
  newsdata,
  productdata,
} from '../../../../redux/widget-box/widget-box.action';

function NewsConnectWidgetBox({ relatedNews }) {
  return (
    <div>
      {relatedNews && relatedNews.length > 0 && (
        <div className="widgetBox-container">
          <h5 className="widget-title">Related News</h5>
          {relatedNews &&
            relatedNews.map((widget) => (
              <CommonWidgetBox
                widgetImage={widget.GlobalIcon}
                widgetContent={widget.Title}
                widgetContentLink={widget.Url}
                widgetDate={widget.strPublishedDate}
                widgetSubContent=""
                singleLinkContent=""
                singleLink=""
              />
            ))}
          <div className="widget-link">
            <a
              href="/news"
              target="_blank"
              className="single-link"
              rel="noreferrer"
            >
              All News ›
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default NewsConnectWidgetBox;
